import React, { Component } from 'react';
import { FormGroup, ControlLabel, ButtonGroup, Button, HelpBlock } from 'react-bootstrap';
import { Grid, Row, Col } from 'react-bootstrap';

class SymbolBox extends Component {

	handleChange(e) {
		this.props.update(e.target.value );
	}

	render() {
		return (
			<Grid>
				<Row>
					<Col>
						<form>
							<FormGroup
								controlId="formBasicDate"
							>
								<ControlLabel style={{display:'block'}}>Simbolo</ControlLabel>
								<ButtonGroup>
									<Button active={this.props.selected==='^GSPC'?true:false} onClick={this.props.update.bind(this, '^GSPC')}>S&P 500</Button>
									<Button active={this.props.selected==='GOOG'?true:false} onClick={this.props.update.bind(this, 'GOOG')}>GOOG</Button>
									<Button active={this.props.selected==='GOOGL'?true:false} onClick={this.props.update.bind(this, 'GOOGL')}>GOOGL</Button>
									<Button active={this.props.selected==='AAPL'?true:false} onClick={this.props.update.bind(this, 'AAPL')}>AAPL</Button>
									<Button active={this.props.selected==='MSFT'?true:false} onClick={this.props.update.bind(this, 'MSFT')}>MSFT</Button>
									<Button active={this.props.selected==='JPM'?true:false} onClick={this.props.update.bind(this, 'JPM')}>JPM</Button>
									<Button active={this.props.selected==='XOM'?true:false} onClick={this.props.update.bind(this, 'XOM')}>XOM</Button>
									<Button active={this.props.selected==='GE'?true:false} onClick={this.props.update.bind(this, 'GE')}>GE</Button>
									<Button active={this.props.selected==='AMZN'?true:false} onClick={this.props.update.bind(this, 'AMZN')}>AMZN</Button>
								</ButtonGroup>
								<HelpBlock>Simbolo da confrontare</HelpBlock>
							</FormGroup>
						</form>
					</Col>
				</Row>
			</Grid>
		);
	}
}

export default SymbolBox;



// WEBPACK FOOTER //
// ./src/components/SymbolsBox.js